import {
  arrayBuilderItemSubsequentPageTitleUI,
  descriptionUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import MedicareCardDescription from '../../components/FormDescriptions/MedicareCardDescription';
import { MedicarePartBDescription } from '../../components/FormDescriptions/MedicarePlanDescriptions';
import { attachmentSchema, attachmentUI } from '../../definitions';
import content from '../../locales/en/content.json';
import { ATTACHMENT_IDS } from '../../utils/constants';

const TITLE_TEXT = content['medicare--part-b-card-title'];
const INPUT_LABELS = {
  cardFront: content['medicare--part-b-card-label--front'],
  cardBack: content['medicare--part-b-card-label--back'],
};
const HINT_TEXT = content['attachments--hint-text'];

export default {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      TITLE_TEXT,
      MedicarePartBDescription,
    ),
    ...descriptionUI(MedicareCardDescription({ variant: 'partB' })),
    medicarePartBFrontCard: attachmentUI({
      title: INPUT_LABELS.cardFront,
      hint: HINT_TEXT,
      attachmentId: ATTACHMENT_IDS.medicareAbCardFront,
    }),
    medicarePartBBackCard: attachmentUI({
      title: INPUT_LABELS.cardBack,
      hint: HINT_TEXT,
      attachmentId: ATTACHMENT_IDS.medicareAbCardBack,
    }),
  },
  schema: {
    type: 'object',
    required: ['medicarePartBFrontCard', 'medicarePartBBackCard'],
    properties: {
      medicarePartBFrontCard: attachmentSchema,
      medicarePartBBackCard: attachmentSchema,
    },
  },
};
